var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        {
          staticClass: "u-visually-hidden",
          attrs: { id: "open_encoding_modal" },
          on: {
            click: function($event) {
              $event.preventDefault()
              _vm.showEncodingModal = true
            }
          }
        },
        [_vm._v("\n    Open\n  ")]
      ),
      _vm._v(" "),
      _c(
        "modal",
        { attrs: { show: _vm.showEncodingModal }, on: { close: _vm.close } },
        [
          _c("div", { staticClass: "c-modal__body" }, [
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.gettext(
                      "Please do not use special characters such as &, < or >"
                    )
                  ) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "c-modal__response u-mb-md u-text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--ghost-primary",
                on: { click: _vm.close }
              },
              [_vm._v(_vm._s(_vm.gettext("Close")))]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d5d977c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d5d977c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/EncodingModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3d5d977c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/EncodingModal.vue
// module chunks = 0